/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2022-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React from 'react';
import PropTypes from 'prop-types'
import './inputDescription.scss'
import TextWithTooltip from "../../textWithTooltip/TextWithTooltip";

const InputDescription = ({description, descriptionFor}) => {
  const descriptionOverlay = <TextWithTooltip id={`input-${descriptionFor}`} placement="top" tooltipText={description} spanClassName="icon-tooltip_icon" />;
  return (<div className="overlay-icon-container">{descriptionOverlay}</div>)
}

InputDescription.propTypes = {
  /* Content to show in the tooltip */
  description:PropTypes.string,
  /* Used to create an ID for the overlay */
  descriptionFor: PropTypes.string,
}

export default InputDescription
